import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallsAPI, HttpOptions } from './abstract/http/calls-api';
import { environment } from '../../../environments/environment';
import { MedicalAidSchemeModel } from '../models/medicalAidSchemeModel';
import { MedicalAidPlanModel } from '../models/medicalAidPlanModel';
import { MedicalAidOptionModel } from '../models/medicalAidOptionModel';

@Injectable({
  providedIn: 'root',
})
export class MedicalAidService extends CallsAPI<any, any[]> {
  protected apiBasePath: string = environment.api_url;
  protected resourcePath: string = '';
  /**
   * Default Options per Request
   * @protected
   * @type {HttpOptions}
   * @memberof HttpApiService
   */
  protected override defaultOptions: HttpOptions = {
    withCredentials: true,
  };

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public getSchemesByCountryId(schemes: number, options?: HttpOptions): Observable<MedicalAidSchemeModel[]> {
    return this.http.get<any>(
      this.buildAction(`schemes/${schemes}`),
      this.buildOptions(options)
    );
  }


  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public getPlansBySchemeId(schemeId: number, options?: HttpOptions): Observable<MedicalAidPlanModel[]> {
    return this.http.get<any>(
      this.buildAction(`plans/${schemeId}`),
      this.buildOptions(options)
    );
  }


  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public getOptionsByPlanId(planId:number, options?: HttpOptions): Observable<MedicalAidOptionModel[]> {
    return this.http.get<any>(
      this.buildAction(`options/${planId}`),
      this.buildOptions(options)
    );
  }
}
